import { supabase } from '../lib/supabase';

// ============================================================
// PARTNER NOTES SERVICE
// ============================================================
export const partnerNotesService = {
  async getByPartner(partnerId) {
    const { data, error } = await supabase
      ?.from('partner_notes')
      ?.select(`
        *,
        author:author_id(id, full_name, email, role)
      `)
      ?.eq('partner_id', partnerId)
      ?.order('created_at', { ascending: false });
    if (error) throw error;
    return data || [];
  },

  async create(partnerId, content) {
    const { data: { user } } = await supabase?.auth?.getUser();
    const { data, error } = await supabase
      ?.from('partner_notes')
      ?.insert({ partner_id: partnerId, content, author_id: user?.id })
      ?.select(`*, author:author_id(id, full_name, email, role)`)
      ?.single();
    if (error) throw error;
    return data;
  },

  async update(id, content) {
    const { data, error } = await supabase
      ?.from('partner_notes')
      ?.update({ content, updated_at: new Date()?.toISOString() })
      ?.eq('id', id)
      ?.select(`*, author:author_id(id, full_name, email, role)`)
      ?.single();
    if (error) throw error;
    return data;
  },

  async remove(id) {
    const { error } = await supabase?.from('partner_notes')?.delete()?.eq('id', id);
    if (error) throw error;
  }
};

// ============================================================
// PARTNER SETUP CONFIG SERVICE
// ============================================================
export const partnerSetupService = {
  async getByPartner(partnerId) {
    const { data, error } = await supabase
      ?.from('partner_setup_config')
      ?.select('*')
      ?.eq('partner_id', partnerId)
      ?.single();
    if (error && error?.code !== 'PGRST116') throw error;
    return data || null;
  },

  async upsert(partnerId, updates) {
    const { data, error } = await supabase
      ?.from('partner_setup_config')
      ?.upsert({ partner_id: partnerId, ...updates, updated_at: new Date()?.toISOString() }, { onConflict: 'partner_id' })
      ?.select()
      ?.single();
    if (error) throw error;
    return data;
  }
};

// ============================================================
// PARTNER HEALTH SERVICE (live data from trainings + lifecycle)
// ============================================================
export const partnerHealthService = {
  async getHealthData(partnerId) {
    const [trainingsRes, lifecycleRes, auditRes] = await Promise.allSettled([
      supabase?.from('partner_trainings')?.select('*')?.eq('partner_id', partnerId)?.order('created_at', { ascending: false }),
      supabase?.from('lifecycle_requests')?.select('*')?.eq('partner_id', partnerId)?.order('created_at', { ascending: false })?.limit(10),
      supabase?.from('audit_trail')?.select('*')?.eq('entity_id', partnerId)?.order('created_at', { ascending: false })?.limit(10)
    ]);

    const trainings = trainingsRes?.status === 'fulfilled' ? (trainingsRes?.value?.data || []) : [];
    const lifecycle = lifecycleRes?.status === 'fulfilled' ? (lifecycleRes?.value?.data || []) : [];
    const audit = auditRes?.status === 'fulfilled' ? (auditRes?.value?.data || []) : [];

    return { trainings, lifecycle, audit };
  }
};
